import { createRoute } from '@tanstack/react-router'
import { authLayoutOnlyGuestRoute } from 'src/layouts/routes'
import { z } from 'zod'

import { LoginPage } from '../pages/LoginPage'

export const authRoute = createRoute({
  getParentRoute: () => authLayoutOnlyGuestRoute,
  component: () => <LoginPage />,
  path: '/auth',
  validateSearch: (search) =>
    z
      .object({
        redirectTo: z.string().optional()
      })
      .parse(search)
})
